import React from 'react';
import CalendarUtils from 'services/CalendarUtils';

// The Framingham Risk Score (FRS) calculator was retired in favour of the
// PREVENT calculator, so the interactive modal has been removed. These
// utilities remain only to parse and render previously-saved FRS notes so
// historical scores still display in the CPP.

const NAME = 'FRS';

// Strict shape match — keep in sync with server isFRSPayload. Free-form
// notes whose name happens to be 'FRS' won't parse and are ignored, so the
// CPP rail won't render JSON for them.
function tryParseFRS(rawNotes) {
  if (typeof rawNotes !== 'string' || rawNotes[0] !== '{') return null;
  let p;
  try {
    p = JSON.parse(rawNotes);
  } catch {
    return null;
  }
  if (!p || p.v !== 1) return null;
  if (typeof p.result !== 'string') return null;
  if (p.gender !== 'Male' && p.gender !== 'Female') return null;
  if (typeof p.totalCholesterol !== 'number' || typeof p.hdl !== 'number') return null;
  if (typeof p.systolicBP !== 'number') return null;
  if (
    typeof p.medication !== 'boolean' ||
    typeof p.cig !== 'boolean' ||
    typeof p.diabetes !== 'boolean'
  )
    return null;
  if (typeof p.calculatedAt !== 'number') return null;
  if (p.source !== 'manual' && p.source !== 'auto-lab') return null;
  return p;
}

function decodeNotes(rawNotes) {
  const parsed = tryParseFRS(rawNotes);
  if (!parsed) return null;
  const when = CalendarUtils.format(parsed.calculatedAt, 'YYYY/MM/DD');
  const isAuto = parsed.source === 'auto-lab';
  const headline = `FRS ${parsed.result}%${isAuto ? ' (auto)' : ''}`;
  const detailJsx = (
    <span>
      TC {parsed.totalCholesterol} / HDL {parsed.hdl} mmol/L
      <br />
      SBP {parsed.systolicBP}
      {parsed.medication ? ' (on med)' : ''}
      {parsed.cig ? ', smoker' : ''}
      {parsed.diabetes ? ', DM' : ''}
    </span>
  );
  return { parsed, when, isAuto, headline, detailJsx };
}

export const FRSCalculatorUtils = {
  NAME,
  tryParseFRS,
  decodeNotes,
  decodeForDisplay(item) {
    const decoded = decodeNotes(item?.value?.notes);
    if (!decoded) return null;
    return {
      text: decoded.headline,
      notes: (
        <span>
          {decoded.detailJsx}
          <br />
          {decoded.isAuto ? 'Auto-updated' : 'Calculated'} {decoded.when}
          {decoded.isAuto && ' — review toggles'}
        </span>
      ),
    };
  },
};
